<div class="panel-wrapper">
    <div class="panel-header">
        <div class="panelHead">
            <span class="panel-header-text">{{booking?.spotBookingType}}</span>
            <span mis-input-icon (click)="close()" class="close-btn"><img src="/assets/images/cancel_24.svg"
                    alt="" /></span>
        </div>
        <div class="booking-id-wrapper">
            <span class="booking-id  master-id" *ngIf="booking?.masterBookingId">Master ID:
                {{booking.masterBookingId}}</span>
            <span class=" booking-id">{{booking.bookingId}}</span>
        </div>
    </div>

    <div class="panel-body">
        <div class="booking-status">
            <span class="booking-date">{{transformDate(booking?.startTime.split(' ')[0])}}</span>
            <span
                [ngClass]="{'booking-status-cancelled': booking.bookingStatus === 'CANCELLED', 'booking-status-active': booking.bookingStatus === 'ACTIVE'}"
                *ngIf="booking.paymentStatus !== 'PROCESSING'">{{booking?.bookingStatus}}</span>
            <span style="cursor: pointer;"><img mat-button [matMenuTriggerFor]="menu" src="assets/menu-icon.svg" alt=""
                    (click)="sideMenu=!sideMenu"></span>
            <mat-menu #menu="matMenu">
                <button (click)="generateInvoive()" mat-menu-item>Generate Invoice</button>
                <button (click)="viewDocument()" mat-menu-item>View Document</button>
                <button (click)="downloadInvoive()" mat-menu-item>Download</button>
            </mat-menu>
        </div>

        <div class="multiTrip-content mt-24" *ngIf="booking.multiDayBooking; else onewayTrip">
            <div class="days displayFlexColumn" *ngFor="let day of multidayTrips; let dayIndex=index">
                <div class="dayStops " *ngFor="let stop of day.stops; let stopIndex=index">
                    <div [ngClass]="stopIndex==0 ? 'pb-24':''">
                        <div *ngIf="stopIndex==0" class="dayCount ">Day-{{day.day}}</div>
                    </div>
                    <div class="each-stop displayFlex fs-14"
                        [ngClass]="(stopIndex==day.stops.length-1 && dayIndex==multidayTrips.length-1 )  ? 'last-day-stop'  : (stopIndex==day.stops.length-1) ? 'last-stop':'each-stop'">
                        <span><img class="icon-small"
                                [src]="(dayIndex==multidayTrips.length-1) ? (stopIndex==day.stops.length-1 ? 'assets/ic-location2.svg' : 'assets/ic-ui-location1.svg' ):  'assets/ic-ui-location1.svg'  "
                                alt=""></span>
                        <div class="displayFlexColumn address-section">
                            <div *ngIf="dayIndex==0 && stopIndex==0" class="boxedContent">{{startTime |
                                twelvehourtimeformatter}}</div>
                            <div>{{stop.address}}</div>
                            <div class="fs-12 geoaraea-label mt-8">{{stop.geoArea}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #onewayTrip>
            <div *ngIf="stopsDetails.length>0" class="trip-content displayFlexColumn mb-12">
                <ng-container *ngFor="let stop of stopsDetails; let i=index;">
                    <div [ngClass]=" stop.pointType == 'END' ? 'endRoute' : 'route' ">
                        <span class="stopImages">
                            <img [src]=" stop.pointType == 'START' ? 'assets/ic-ui-location1.svg' : stop.pointType == 'END' ? 'assets/ic-location2.svg' : 'assets/ic-ui-seperator.svg'"
                                alt="stopTypeImg">
                        </span>
                        <div [ngClass]="stop.pointType == 'END'? 'endRouteData' : 'routeData' ">
                            <span *ngIf="stopsDetails[i]['time'] && stopsDetails[i]['time'] != ''" class="boxedContent">
                                {{stopsDetails[i]['time'] | twelvehourtimeformatter}} </span>
                            <span class="routeAddress fs-12">{{stopsDetails[i]['address']}}</span>
                            <span class="landmark" *ngIf="stopsDetails[i]['geoArea']"> {{stopsDetails[i]['geoArea'] |
                                titlecase}} </span>
                            <span *ngFor="let rider of stop.riders" class="riderData">
                                <span class="boardingIcon">
                                    <img [src]=" rider.boardingType == 'PickUp' ? 'assets/ic-mobile-top arrow on-24.png' : 'assets/ic-mobile-top arrow on-24.svg' "
                                        alt="boardingTypeImg">
                                </span>
                                <span
                                    [ngClass]=" rider.boardingType == 'PickUp' ? 'pickup' : 'dropoff'">{{rider.boardingType
                                    == 'PickUp' ? 'Pickup' : 'Dropoff'}}</span>
                                <span class="riderName font-weight-700 fs-12">{{rider.name | titlecase}}</span>
                            </span>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-template>

        <!-- ------------passenger details  -->
        <div class="requester-content mb-12">
            <div>
                <div class="mb-12">
                    <span class="fs-14 color-000 font-weight-700">Passenger Details</span>
                </div>
                <div class="" *ngFor="let rider of passanger;let i = index">
                    <div [ngClass]="i==booking.stops[0].riders.length-1 ? '' : 'mb-24 padding-bottom-16 border-bottom-E0E0E0' "
                        class="displayFlexRow displayFlexSpaceBetween ">
                        <div>
                            <div class="fs-12 color-000 mb-4 overflow-ellipse"
                                matTooltip="{{ rider.name}} ({{rider.emplId}})" matTooltipClass="booking-table-tooltip">
                                {{ rider?.name || '--'}} ({{rider?.emplId}})</div>
                            <div class=" label-color-929DAB mb-2 overflow-ellipse fs-12" matTooltip="{{rider.email}}"
                                matTooltipClass="booking-table-tooltip">{{rider?.email || '--'}}</div>
                            <div class="fs-12 displayFlexRow label-color-929DAB flex-wrap ">
                                <span> {{(rider?.mobile | formatPhoneNumber : rider) || '--'}}</span>
                                <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"
                                        alt=""></span>
                                <span> {{(rider?.alternateMobile | formatPhoneNumber : rider) ||''}} </span>
                                <span class="overflow-ellipse" matTooltip="{{rider.costCenter}}"
                                    matTooltipClass="booking-table-tooltip"> {{rider?.costCenter || '--'}}</span>
                            </div>
                            <div class="fs-12 displayFlexRow label-color-929DAB flex-wrap ">
                                <span> {{rider?.department || '--'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ---marshall details --- -->
        <div *ngIf="booking.guardReq" class="requester-content mb-12">
            <div >
                <div class="mb-12">
                    <span class="fs-14 color-000 font-weight-700">Marshall Details</span>
                </div>
                <div *ngIf="marshall">
                    <div class="displayFlexRow displayFlexSpaceBetween ">
                        <div [ngClass]="showOtpProperty ? 'riderDetails':''">
                            <div class="fs-12 color-000 mb-4 overflow-ellipse"
                                matTooltip="{{ marshall.name}} ({{marshall.emplId}})"
                                matTooltipClass="booking-table-tooltip">
                                {{ marshall?.name || '--'}} ({{marshall?.emplId}})</div>
                            <div class=" label-color-929DAB mb-2 overflow-ellipse fs-12" matTooltip="{{marshall.email}}"
                                matTooltipClass="booking-table-tooltip">{{marshall?.email || '--'}}</div>
                            <div class="fs-12 displayFlexRow label-color-929DAB ">
                                <span> {{marshall?.mobile || '--'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!marshall" class="label-color-929DAB mb-2 ">
                    Details will be available once Marshal is assigned.
                </div>
            </div>
        </div>

        <!-- ----cabs details --- -->
        <div class="cab-content mb-12">
            <div class="cab-content-wrapper">
                <div class=" displayFlexRow displayFlexSpaceBetween">
                    <div>
                        <div class="fs-12 label-color-929DAB mb-4">Vendor</div>
                        <div class="fs-12 color-000">{{booking?.vendor?.vendorName || '--'}}</div>
                    </div>
                </div>
                <div class="mt-16 displayFlexColumn ">
                    <div class="fs-12 label-color-929DAB mb-4">Cab Details</div>
                    <div class="fs-12 displayFlexRow color-000">
                        <span> {{booking?.cab?.registration || '--'}}</span>
                        <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"></span>
                        <span>{{booking?.cab?.cabType.name || '--'}}</span>
                    </div>
                </div>
                <div class="mt-16 displayFlexColumn ">
                    <div class="fs-12 label-color-929DAB mb-4">Driver Details</div>
                    <div class="fs-12 displayFlexRow color-000">
                        <span> {{booking?.cab?.driver?.name || '--'}}</span>
                        <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"></span>
                        <span>{{booking?.cab?.driver?.phoneNumbers[0] || '--'}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="requester-content mb-12">
            <div class=" width-full">
                <div class="displayFlexColumn">
                    <div class="mb-12">
                        <span class="fs-14 color-000 font-weight-700">Requester Details</span>
                    </div>
                    <div class="">
                        <div class="fs-12 color-000 mb-4">{{ booking?.requester?.name || '--'}}
                            ({{booking?.requester?.emplId}})</div>
                        <div class=" label-color-929DAB mb-2 fs-12">{{booking?.requester?.email || '--'}}</div>
                        <div class="fs-12 displayFlexRow label-color-929DAB">
                            <span> {{booking?.requester?.mobile || '--'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel-footer">
            <button mis-button type="primary" size="sm" class="edit" (click)="edit()">Edit</button>
        </div>
    </div>